import React from 'react'
import { NavLink } from 'react-router-dom';
import './Policys.css';


const TermsService = () => {
  const navLinks = [
    { name: 'PRIVACY POLICY', path: '/PrivacyPolicy' },
    { name: 'REFUND POLICY', path: '/RefundPolicy' },
    { name: 'TERMS OF SERVICES', path: '/TermsService' },
  ];

  return (
    <div className="privacy-container">
      {/* Navigation Bar */}
      <nav className="nav-bar">
        {navLinks.map((link) => (
          <NavLink
            key={link.name}
            to={link.path}
            // React Router provides an 'isActive' boolean automatically
            className={({ isActive }) => 
                isActive ? "nav-button active" : "nav-button"
            }
          >
            <span className="nav-text">{link.name}</span>
          </NavLink>
        ))}
      </nav>

     <main className="content-wrapper">
  <div className="page-header">
    <h1 className="page-title">TERMS OF USE</h1>
    <p className="page-subtitle">
      Guidelines for using our platform and attending our events
    </p>
  </div>

  {/* Overview */}
  <div className="section-row">
    <h2 className="section-title">Overview</h2>
    <div className="section-body">
      <p className="section-lead">
        Welcome to Event House. By accessing our website, mobile application,
        or attending any of our events, you agree to comply with and be bound
        by these Terms of Use. Please read them carefully before using our
        services.
      </p>
    </div>
  </div>

  {/* Use of Platform */}
  <div className="section-row">
    <h2 className="section-title">Use of Our Platform</h2>
    <div className="section-body">
      <p>
        Event House provides access to curated social and experiential events.
        You agree to use our platform responsibly and only for lawful purposes.
        Any misuse, attempt to disrupt services, or violation of applicable
        laws may result in restricted access.
      </p>
    </div>
  </div>

  {/* Eligibility */}
  <div className="section-row">
    <h2 className="section-title">Eligibility</h2>
    <div className="section-body">
      <p>
        By registering for an event, you confirm that you meet the eligibility
        requirements mentioned for that event. Providing false or misleading
        information may result in cancellation of your booking without refund.
      </p>
    </div>
  </div>

  {/* Event Participation */}
  <div className="section-row">
    <h2 className="section-title">Event Participation & Conduct</h2>
    <div className="section-body">
      <p>
        All attendees are expected to behave respectfully and responsibly
        during Event House experiences. Harassment, inappropriate behaviour,
        or disruption of the event environment will not be tolerated and may
        lead to removal from the event without refund.
      </p>
    </div>
  </div>

  {/* Ticketing */}
  <div className="section-row">
    <h2 className="section-title">Tickets & Access</h2>
    <div className="section-body">
      <p>
        Tickets are valid only for the specific event, date, and time mentioned
        at the time of booking. Entry may be denied if verification requirements
        are not met or if venue capacity or safety guidelines require it.
      </p>
    </div>
  </div>

  {/* Intellectual Property */}
  <div className="section-row">
    <h2 className="section-title">Intellectual Property</h2>
    <div className="section-body">
      <p>
        All content on the Event House platform, including text, images,
        branding, and designs, is the property of Event House or its partners
        and may not be copied, distributed, or reused without prior permission.
      </p>
    </div>
  </div>

  {/* Liability */}
  <div className="section-row">
    <h2 className="section-title">Limitation of Liability</h2>
    <div className="section-body">
      <p>
        Event House is not responsible for personal belongings, personal
        interactions, or outcomes arising from participation in events.
        Attendance is voluntary and at the attendee’s own discretion.
      </p>
    </div>
  </div>

  {/* Changes */}
  <div className="section-row">
    <h2 className="section-title">Changes to These Terms</h2>
    <div className="section-body">
      <p>
        Event House reserves the right to update or modify these Terms of Use
        at any time. Continued use of our platform or participation in events
        constitutes acceptance of the updated terms.
      </p>
    </div>
  </div>
</main>

    </div>
  )
}

export default TermsService